import React, { useState, useEffect, useLayoutEffect, useRef } from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { Tooltip, OverlayTrigger } from 'react-bootstrap'
import classnames from 'classnames'
import { toastr } from 'react-redux-toastr'
import { isMobile } from 'react-device-detect'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Auth from '../../Auth'
import CustomButton from '../../CustomButton'
import Controls from '../../Controls'
import { getDeviceById, getDevicesLive, stopDevicesLive } from '../../../action/DeviceActions'
import { getUserInfo } from '../../../action/ClientActions'
import { apiCall } from '../../../action/RouterActions'
import useInterval from '../../common/UseInterval'
import { detectRSSIQuality } from '../../helpers/helperVehicle'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"

const LiveVideoContainer = (props) => {
	const navigate = useNavigate();
	const routeParams = useParams();
	const { loaderModal, toggleLoaderModal } = props;
	const { t } = useTranslation('translation', { keyPrefix: 'components.liveVideoContainer' });

	const live_player = useRef(null)
	const player = useRef(null)
	const timerPleaseContinueWaiting = useRef(null) // timer, updates message to 'Please continue waiting...' in 7 secs after start getting m3u8
	const timerStartPlayback = useRef(null) // timer, in 45secs (exception is "Arrow Security" company - FWSD-8493) after the stream starting will display "The stream will be stopped in 15 secs".

	const [user, setUser] = useState(null);
	const [userRole, setUserRole] = useState('');
	const [device, setDevice] = useState('');
	const [channel, setChannel] = useState('');
	const [showLiveOut, setShowLiveOut] = useState(false);
	const [showLiveOutStopped, setShowLiveOutStopped] = useState(false);
	const [url, setUrl] = useState('');
	const [modem_rssi, setModem_rssi] = useState(0);
	const [rssi_object, setRssi_object] = useState('');
	const [channels_available, setChannels_available] = useState(null);
	const [showCalibrationBox, setShowCalibrationBox] = useState(false);
	const [showAdasCalibrationBox, setShowAdasCalibrationBox] = useState(false);
	const [m3u8Requests, setM3u8Requests] = useState(0);
	const [message, setMessage] = useState('');
	const [switchingIsAvailable, setSwitchingIsAvailable] = useState(false);

	const [delayDeviceStatusAndRSSIOnline, setDelayDeviceStatusAndRSSIOnline] = useState(null) // interval to request RSSIQuality each 10 secs
	const [delayStreamStopped, setDelayStreamStopped] = useState(null) // interval of counting 15 secs to stream stopping (without Continue Watching clicking), is called each 1 sec
	const [player_out, setPlayer_out] = useState(15) // stores mount of seconds to stream stopping (from 15 to 5)

	const [forceStopPlayer, setForceStopPlayer] = useState(false)
	const [showZoomControls, setShowZoomControls] = useState(false)

	const playbackLengthRef = useRef(null); // the length of video playback before Continue watching videos after 45 secs of livestreaming (exception is "Arrow Security" company - FWSD-8493 - 285 secs)

	useLayoutEffect(() => {
		document.body.classList.add('live-video-page');


		if (isMobile) {
			if (window.innerHeight < window.innerWidth) {
				document.body.classList.remove('portrait');
				document.body.classList.add('landscape');
			}
			else {
				document.body.classList.remove('landscape');
				document.body.classList.add('portrait');
			}

			$(window).on('orientationchange', () => {
				if ((window.orientation && Math.abs(window.orientation) === 90) || (window.innerHeight > window.innerWidth)) {
					document.body.classList.remove('portrait');
					document.body.classList.add('landscape');
				}
				else {
					document.body.classList.remove('landscape');
					document.body.classList.add('portrait');
				}
			});
		}
	}, []);

	useEffect(() => {
		// flag that LiveStream was called from Webfleet page with JWT authorization
		const wfAuthToken = localStorage.getItem('wfauth_token')
		if (location.pathname.includes('live/stream') && wfAuthToken) {
			// set token to axios common header
			new Auth().setAxiosAuthToken(wfAuthToken)
		}

		setChannel('')
		setShowLiveOut(false)
		setShowLiveOutStopped(false)
		setUrl('')
		setChannels_available(null) // '1,2'

		getUserInfo()
			.then((res, err) => {
				const user = res.data.response.user;
				const userRole = user.roles[0];
				const userPermission = user.company_data
				if (!userPermission.live_active && ['fleet_manager', 'fleet_maintainer', 'group_manager', 'user'].indexOf(userRole) > -1) {
					navigate('/not-found');
				}
				setUserRole(userRole);
				setUser(user);

				const params = {
					deviceId: routeParams.deviceId,
					userRole: res.data.response.user.roles[0],
					includeData: 'modem_rssi',
				}

				getDeviceById(params)
					.then((res1, err1) => {
						if (res1.status === 200) {
							const { device } = res1.data.response
							const vehicleName = device.vehicle_name || device.device_id;
							document.title = `${vehicleName} - Live`;

							setDevice(device);
							setModem_rssi(+device.modem_rssi)
							setRssi_object(detectRSSIQuality(+device.modem_rssi))
							setDelayDeviceStatusAndRSSIOnline(10000)

							if (device.channel_available) {
								const defaultChannel = device.channel_available.split(',')[0]
								setChannel(defaultChannel);
								setChannels_available(device.channel_available);
								getLiveToken(defaultChannel);
							} else {
								setChannels_available('');
							}
						}
					}).catch((error) => { });
			}).catch((error) => {
				console.log('!LiveVideoLayout getUserInfo componentDidMount error: ', error.response, error);

				new Auth().deauthenticateUser();
				location.href = '/';
			});

		return () => {
			document.body.classList.remove('live-video-page');
			setDelayDeviceStatusAndRSSIOnline(null)
			clearTimer();
			stopLiveVideo(() => {
				destroyPlayer();
			})
		}
	}, []);


	useEffect(() => {
		if (forceStopPlayer) {
			stopLiveVideo(
				() => {
					destroyPlayer()
					clearTimer()
					window.close()
				},
				null,
				true
			)
		}
	}, [forceStopPlayer])

	useEffect(() => {
		const handleUnload = (event) => {
			setForceStopPlayer(true)
		};

		window.addEventListener('beforeunload', handleUnload);

		// Cleanup the event listener on component unmount
		return () => {
			window.removeEventListener('beforeunload', handleUnload);
		};
	}, [])

	useInterval(() => {
		const params = {
			deviceId: device.device_id,
			userRole,
			includeData: 'modem_rssi',
		}
		getDeviceById(params)
			.then((res, err) => {
				const { device } = res.data.response
				setDevice(device);
				setModem_rssi(+device.modem_rssi);
				setRssi_object(detectRSSIQuality(+device.modem_rssi))

				if (!device.ads_online) {
					setMessage(t('errCameraOffline'))
					toastr.error(t('errCameraOffline'));
				}
			})
			.catch((error) => {
				console.log('useInterval getDeviceById error: ', error)
			});
	}, delayDeviceStatusAndRSSIOnline);

	useEffect(() => {
		if (showZoomControls) {
			$(document).mouseup((e) => { if (($('.vjs-zoom__container')[0] && !$('.vjs-zoom__container')[0].contains(e.target)) && !$('.btn-zoom')[0].contains(e.target)) { setShowZoomControls(false) } });
		}
	}, [showZoomControls]);

	useInterval(() => {
		setPlayer_out((prevState) => prevState - 1)
		if (player_out === 1) {
			setDelayStreamStopped(null)
			stopLiveVideo(() => {
				setUrl('');
				setShowLiveOut(false);
				setShowLiveOutStopped(true);
			},
				null,
				true
			)
		}
	}, delayStreamStopped);

	// FWSD-8493
	useEffect(() => {
		if (!device || !device.company_id) return;
		// Prevent recalculation
		if (playbackLengthRef.current !== null) return;

		// the length of video playback before Continue watching videos after 45 secs of livestreaming (exception is "Arrow Security" company - FWSD-8493 - 285 secs)
		playbackLengthRef.current = device.company_id === 3165 ? 285000 : 45000

		startTimer()
	}, [device]);

	const continueWatching = () => {
		clearTimer();
		getLiveToken(channel);
	}

	const clearTimer = () => {
		setDelayStreamStopped(null)
		setPlayer_out(15)

		clearTimeout(timerStartPlayback.current)
		timerStartPlayback.current = null

		clearTimeout(timerPleaseContinueWaiting.current)
		timerPleaseContinueWaiting.current = null

		setShowLiveOut(false);
		setShowLiveOutStopped(false);
	}

	const stopTimer = () => {
		clearTimer();
		startTimer();
	}

	const startTimer = () => {
		if (!playbackLengthRef.current) return;

		if (timerStartPlayback.current) {
			clearTimeout(timerStartPlayback.current)
			timerStartPlayback.current = null
		}

		timerStartPlayback.current = setTimeout(() => {
			setShowLiveOut(true)
			setPlayer_out(15)
			setDelayStreamStopped(1000)
		}, playbackLengthRef.current);
	}

	const getVideoResolution = () => {
		if (live_player.current) {
			const videoElement = live_player.current.querySelector('video');
			if (videoElement && videoElement.videoWidth && videoElement.videoHeight) {
				const v = (videoElement.videoHeight / videoElement.videoWidth) * 1.777;
				videoElement.style.transform = `scaleX(${v})`;
			}
		}
	}

	const changeChannel = (e, argChannel) => {
		console.log('changeChannel clicked: ', argChannel)
		e.preventDefault()
		const channel_prev = channel;
		setChannel(argChannel);
		setUrl('');
		setSwitchingIsAvailable(false);
		setShowZoomControls(false);

		clearTimer();
		if (player.current) {
			console.log('player pause')
			player.current.pause()
		}
		stopLiveVideo(
			() => getLiveToken(argChannel),
			channel_prev,
		)
	}

	const stopLiveVideo = (callback, channelData = null, stop = false) => {
		const active_device_id = routeParams.deviceId
		const _channel = channelData || channel;

		if (player.current) {
			if (stop) {
				$('.player-poster').addClass('stopped');
				player.current.stop();
			} else {
				player.current.pause();
			}
		}

		let data = { device_id: active_device_id, channel: _channel };
		stopDevicesLive(data)
			.then((res, err) => {
				if (typeof callback === 'function') {
					return callback();
				}

			}).catch((error) => {
				console.log('!stopLiveVideo stopDevicesLive error: ', error.response, error);
				toastr.error(t('errStopStream'))
			});
	}

	const getLiveToken = (channelData = null, errorMessage = null) => {
		const active_device_id = routeParams.deviceId;
		const _channel = channelData || channel;

		toggleLoaderModal(true);
		setM3u8Requests(m3u8Requests + 1);
		setMessage(t('errLoadingStream'));

		if (timerPleaseContinueWaiting.current) {
			clearTimeout(timerPleaseContinueWaiting.current)
			timerPleaseContinueWaiting.current = null
		}
		timerPleaseContinueWaiting.current = setTimeout(() => {
			setMessage(t('errStreamStillLoading'));
		}, 7000)

		const data = { device_id: active_device_id, channel: _channel };
		getDevicesLive(data)
			.then((res, err) => {
				setUrl(res.data.response.url);
				setModem_rssi(+res.data.response.modem_rssi);
				setM3u8Requests(0);
				detectRSSIQuality(+res.data.response.modem_rssi)
				if (player.current) {
					player.current.load(res.data.response.url)
				}
				else {
					console.log('Player Creeation')

					$('.player-poster').removeClass('stopped');
					player.current = new Clappr.Player({
						parent: live_player.current,
						source: res.data.response.url,
						mimeType: 'application/x-mpegURL',
						autoPlay: true,
						disableErrorScreen: true,
						exitFullscreenOnEnd: false,
						playInline: true,
						hideMediaControl: true,
						width: '100%',
						height: '100%',
						playback: {
							hlsjsConfig: {
								// debug: true,
								levelLoadingTimeOut: 30000,
								maxLoadingDelay: 10,
							},
							triggerFatalErrorOnResourceDenied: true,
						},
						events: {
							onError: (e) => {
								console.log('onError Clappr Error: ', e);
								if (e.raw.details === 'manifestLoadError') {
									setMessage(t('errPlayVideo'));
									if (timerPleaseContinueWaiting.current) {
										clearTimeout(timerPleaseContinueWaiting.current)
										timerPleaseContinueWaiting.current = null
									}
								}

								const params = {
									log_type: 'error',
									message: JSON.stringify({ title: 'LiveVideo Error, PLAYER_ERROR', device: active_device_id, channel: _channel, user: user.id, code: e.code, description: e.description })
								}
								apiCall('POST', '/elasticsearch/log', params)
							},
							onReady: (e) => {
								console.log('onReady Clappr Error: ', e);
								setMessage('')
								if (timerPleaseContinueWaiting.current) {
									clearTimeout(timerPleaseContinueWaiting.current)
									timerPleaseContinueWaiting.current = null
								}
							}, //Fired when the player is ready on startup
							onPlay: (e) => {
								console.log('onPlay Clappr Error: ', e);
								getVideoResolution();
								setTimeout(() => {
									setSwitchingIsAvailable(true)
								}, 1000);
							}, //Fired when player starts to play
							onPause: (e) => {
								console.log('onPause Clappr Error: ', e);
							}, //Fired when player pauses
							onStop: (e) => {
								console.log('onStop Clappr Error: ', e);
								// onStop event does not see updated/current useState values, in particular the channel value
								setForceStopPlayer(true)
							}, //Fired when player stops
							onEnded: (e) => {
								console.log('onEnded Clappr Error: ', e);
							}, //Fired when player ends the video
						}
					});
				}
				startTimer();

				toggleLoaderModal(false);
			}).catch((error) => {
				console.log('Error getDevicesLive error: ', error)
				if (m3u8Requests < 1) {
					stopLiveVideo(
						() => getLiveToken(channel),
						channel,
					)
				} else {
					setM3u8Requests(0)
					toggleLoaderModal(false);
					console.error('getDevicesLive error: ', error);
					toastr.error(t('errCheckCameraOnline'));
					setMessage(t('errPlayVideo'))

					const params = {
						log_type: 'error',
						message: JSON.stringify({ title: `LiveVideo Error, ${errorMessage || 'get m3u8 link error'}`, device: active_device_id, channel: _channel, user: user.id })
					}
					apiCall('POST', '/elasticsearch/log', params)
				}
			});
	}

	const destroyPlayer = () => {
		if (player.current) {
			player.current.destroy();
		}
		player.current = null;
	}

	const calibrationAccess = ['system_admin', 'customer_service', 'partner'].includes(userRole);

	const activeChannel = (channelData) => {
		if (channel === channelData) {
			return true;
		}
	}

	const channelsList = () => {
		if (channels_available && channels_available.length) {
			const option = []
			channels_available.split(',').map((elem, index) => {
				option[index] = (
					<li key={index} className={classnames('list-inline-item', { active: activeChannel(elem) })}>
						<a href="/" onClick={(e) => changeChannel(e, elem)} className={`${activeChannel(elem) || !switchingIsAvailable ? 'disabled' : ''}`}>{elem}</a>
					</li>
				)
			})
			return (
				<ul className="list-inline chanels-list">
					{option}
				</ul>
			)
		}

		if (channels_available !== null) {
			return (
				<div>{t('noEnabledChannels')}</div>
			)
		}
	}

	const element = document.getElementsByTagName('video')[0];
	const style = { bottom: '0px', right: '0px' };

	// console.log('STATE LiveVideoContainer device: ', device )
	// console.log('STATE LiveVideoContainer user: ', user )

	return (
		<div>
			<div className="live-video-player new-window-video" style={{ position: 'fixed', top: '0', left: '0', right: '0', bottom: '35px' }}>
				<TransformWrapper>
					<Controls
						element={element}
						style={style}
						changeChannel={channel}
						showZoomControls={showZoomControls}
					/>
					<TransformComponent>
						<div className="live-video-container" ref={live_player} style={{ width: '100%', height: '100%' }} />
					</TransformComponent>
				</TransformWrapper>
				{+channel === 1 && showAdasCalibrationBox && (
					<div className="calibration-box-adas live-stream">
						<div className="mibble-calibration-bar" />
						<div className="middle-calibration-line" />
						<div className="bottom-calibration-bar" />
					</div>
				)}
				{
					+channel === 2 && showCalibrationBox && (
						<div className="calibration-box" />
					)
				}
				{(() => {
					if (showLiveOut) {
						return (
							<div className="continue-watching">
								{/* The stream will be stopped in <span id="timer-out">15</span> seconds */}
								{t('continueWatching')} <span id="timer-out">{player_out}</span> {t('seconds')} <CustomButton
									variant="primary-outline"
									style={{ padding: '2px' }}
									onClick={stopTimer}
								>
									{t('btnContinueWatching')}
								</CustomButton>
							</div>
						)
					}
					if (showLiveOutStopped) {
						return (
							<div className="continue-watching">
								{t('streamStopped')} <CustomButton
									variant="primary-outline"
									style={{ padding: '2px' }}
									onClick={continueWatching}
								>
									{t('btnContinueWatching')}
								</CustomButton>
							</div>
						)
					}
				})()}
				{!!message && <div className="message">{message}</div>}
				{loaderModal}
			</div>

			<div className="live-video-channels">
				{!!modem_rssi && !!rssi_object
					? (
						<OverlayTrigger
							placement="top"
							delayHide={100}
							overlay={
								<Tooltip id="sidemenu-tooltip" className="tooltip custom-tooltips rssi-tooltips">
									<p>{t('networkSignalStrength')} {rssi_object.title}</p>
									{rssi_object.description}
								</Tooltip>
							}
						>
							<div className="rssi-signal">
								<img src={`/images/${rssi_object.image}`} alt={t('networkSignalStrength')} />
								{t('signalStrength')}
							</div>
						</OverlayTrigger>
					)
					: <div style={{ width: '150px' }} />
				}
				{channelsList()}
				<div>
					<CustomButton
						variant="link"
						style={{ marginRight: '15px', textDecorationLine: 'none' }}
						prefix="btn-zoom"
						onClick={() => setShowZoomControls(!showZoomControls)}
					>
						{t('btnZoom')}
					</CustomButton>

					{calibrationAccess
						? (
							<CustomButton
								variant="primary-outline"
								size="sm"
								prefix="calibration-btn"
								onClick={() => {
									if (+channel === 1) {
										setShowAdasCalibrationBox(!showAdasCalibrationBox)
									} else if (+channel === 2) {
										setShowCalibrationBox(!showCalibrationBox)
									}
								}}
							>
								{t('toggleCalibrationBox')}
							</CustomButton>
						)
						: <div style={{ width: '150px' }} />
					}
				</div>
			</div>
		</div>
	);
}

export default connect(
	state => ({
		loaderModal: state.loader.loaderModal
	}),
	dispatch => ({
		toggleLoaderModal: (show) => {
			dispatch({ type: 'TOGGLE_LOADER_MODAL', payload: show });
		}
	})
)(LiveVideoContainer);
